import React from "react";

export default function Footer() {
  return (
    <div>
      <footer className="footer text-white">
        <div className="container">
          <footer className="py-5">
            <div className="row">
              <div className="col-md-4 pb-4">
                <h5>About-Us</h5>
                <hr className='hr w-25 ' />
                <p>
                  BYTLAS INTLLIGENCE PRIVATE LIMITED Professional Consulting
                  from Functional Expertise for Software Solution
                  Digitalization, Process Automation, Data Analysis, BI
                  Visualization with Interactive Insights (AI) Artificial
                  intelligence, (ML) Machine Learning
                </p>
              </div>
              <div class="col-md-4 pb-4">
                <h5>Contact</h5>
                <hr className= 'hr w-25 ' />
                <p>
                  <i class="fa fa-map-marker me-3"></i>
                  <a
                    href="https://share.google/Hxre95n841H4VlfWZ" target={"blank"}
                    className="link-light text-decoration-none"
                  >
                    Maharashtra, Thane
                  </a>
                </p>
                <p>
                  <i class="fa fa-phone me-3"></i>
                  <a
                    href="tel:918169886795"
                    className="link-light text-decoration-none"
                  >
                    +91-81698 86795
                  </a>
                </p>
                <p>
                  <i class="fa fa-envelope me-3"></i>
                  <a
                    href="mailto:info@bytlasintelligence.com.com"
                    className="link-light text-decoration-none"
                  >
                    info@bytlasintelligence.com
                  </a>
                </p>

                <p>
                  <i class="fa fa-shield-halved me-3"></i>
                  <a
                    href="/Privacypolicy"
                    className="link-light text-decoration-none"
                  >
                    Privacy  Policy
                  </a>
                </p>

                <p>
                  <i class="fa fa-file me-3"></i>
                  <a
                    href="/TermsOfService"
                    className="link-light text-decoration-none"
                  >
                    Terms Of Service
                  </a>
                </p>

              </div>
              <div className="col-md-4 pb-3">
                <form>
                  <h5>Subscribe to our newsletter</h5>
                  <hr className='hr w-25 ' />
                  <p>Monthly digest of what's new and exciting from us.</p>
                  <div className="d-flex flex-column flex-row w-100 gap-2">
                    <label for="newsletter1" className="visually-hidden">
                      Email address
                    </label>
                    <input
                      id="newsletter1"
                      type="mail"
                      className="form-control"
                      placeholder="Email address"
                    />
                    <label for="newsletter1" className="visually-hidden">
                      Meaasage
                    </label>
                    <textarea
                      id="newsletter1"
                      type=""
                      className="form-control"
                      placeholder="Message"
                    />
                    <button
                      className="btn  btn-primary rounded-pill px-5"
                      type="button"
                    >
                      Subscribe
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top">
              <p>&copy; {new Date().getFullYear()} Bytlas Intelligence Pvt. Ltd., All rights reserved.</p>
              <ul className="list-unstyled d-flex">

            <ul className="d-flex list-unstyled">
              <li className="ms-3">
                <a
                  className="link-light social-icon facebook"
                  href="https://www.facebook.com/profile.php?id=61563516873369"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-facebook fa-2x"></i>
                </a>
              </li>

              <li className="ms-3">
                <a
                  className="link-light social-icon instagram"
                  href="https://www.instagram.com/bytlasintelligence"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-instagram fa-2x"></i>
                </a>
              </li>

              <li className="ms-3">
                <a
                  className="link-light social-icon linkedin"
                  href="https://www.linkedin.com/company/bytlasintelligence"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-linkedin fa-2x"></i>
                </a>
              </li>

              <li className="ms-3">
                <a
                  className="link-light social-icon google"
                  href="https://g.co/kgs/KUetMSP"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-google fa-2x"></i>
                </a>
              </li>

              <li className="ms-3">
                <a
                  className="link-light social-icon whatsapp"
                  href="https://whatsapp.com/channel/0029VamTI4bGE56lo9onpM3A"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-whatsapp fa-2x"></i>
                </a>
              </li>
            </ul>


                

                {/* <li className="ms-3"><a
                                    href="https://m.facebook.com/people/ByssanInternational-Digitalworld/100081238291125/"
                                    target="_blank"
                                >
                                    <span class="fa fa-facebook"></span>
                                </a></li>
                                <li className="ms-3"><a href="https://twitter.com/" target="_blank">
                                    <span class="fa fa-twitter"></span>
                                </a></li>
                                <li className="ms-3"><a href="https://instagram.com/" target="_blank">
                                    <span class="fa fa-instagram"></span>
                                </a></li>
                                <li className="ms-3"><a href="https://youtube.com" target="_blank">
                                    <span class="fa fa-youtube"></span>
                                </a></li>
                                <li className="ms-3"><a href="https://github.com" target="_blank">
                                    <span class="fa fa-github"></span>
                                </a></li> */}
              </ul>
            </div>
          </footer>
        </div>
        <div id="progress">
        <span id="progress-value"><i class="fa-solid fa-arrow-up"></i></span>
        </div>
      </footer>
    </div>
  );
}
